'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fal';
var iconName = 'hospital';
var width = 640;
var height = 512;
var aliases = [127973,62589,"hospital-alt","hospital-wide"];
var unicode = 'f0f8';
var svgPathData = 'M160 64c0-35.3 28.7-64 64-64L416 0c35.3 0 64 28.7 64 64l0 32 96 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-160 0s0 0 0 0l-64 0-64 0-64 0s0 0 0 0L64 512c-35.3 0-64-28.7-64-64L0 160c0-35.3 28.7-64 64-64l96 0 0-32zM480 336l0 144 96 0c17.7 0 32-14.3 32-32l0-128-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-64-80 0c-8.8 0-16-7.2-16-16s7.2-16 16-16l80 0 0-32c0-17.7-14.3-32-32-32l-96 0 0 208zM160 128l-96 0c-17.7 0-32 14.3-32 32l0 32 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 64 80 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-80 0 0 128c0 17.7 14.3 32 32 32l96 0 0-352zM448 336l0-272c0-17.7-14.3-32-32-32L224 32c-17.7 0-32 14.3-32 32l0 416 64 0 0-64c0-35.3 28.7-64 64-64s64 28.7 64 64l0 64 64 0 0-144zm-96 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 64 64 0 0-64zM304 64l32 0c13.3 0 24 10.7 24 24l0 16 16 0c13.3 0 24 10.7 24 24l0 32c0 13.3-10.7 24-24 24l-16 0 0 16c0 13.3-10.7 24-24 24l-32 0c-13.3 0-24-10.7-24-24l0-16-16 0c-13.3 0-24-10.7-24-24l0-32c0-13.3 10.7-24 24-24l16 0 0-16c0-13.3 10.7-24 24-24zm8 56c0 8.8-7.2 16-16 16l-24 0 0 16 24 0c8.8 0 16 7.2 16 16l0 24 16 0 0-24c0-8.8 7.2-16 16-16l24 0 0-16-24 0c-8.8 0-16-7.2-16-16l0-24-16 0 0 24z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHospital = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;